import React, { useState, useEffect, useMemo } from 'react';
import BTable from "react-bootstrap/Table";
import {Button, Form, Row, Col} from "react-bootstrap";
import { useTable, useRowSelect, useFilters, useSortBy, useExpanded, usePagination } from 'react-table';
import InfiniteScroll from "react-infinite-scroll-component";

const SubRowTable = ({columns, data, target, setSelectedRows, showRowExpansion, skipPageResetRef}) => {


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
	rows,
	selectedFlatRows,
        prepareRow,
	visibleColumns,
	setHiddenColumns,
	state: {selectedRowIds}
    } = useTable(
        {
            columns,
            data,
	    autoResetPage: !skipPageResetRef.current,
            autoResetExpanded: !skipPageResetRef.current,
            autoResetGroupBy: !skipPageResetRef.current,
            autoResetSelectedRows: !skipPageResetRef.current,
            autoResetSortBy: !skipPageResetRef.current,
            autoResetFilters: !skipPageResetRef.current,
            autoResetRowState: !skipPageResetRef.current,

        },
        useSortBy,
	useExpanded,
	useRowSelect
    )

    useEffect(()=>{
        if (selectedFlatRows && setSelectedRows) {
            setSelectedRows(selectedFlatRows);
        }
    },[
        selectedRowIds
    ]);
    
    return (
	<BTable className="table" hover {...getTableProps()}>
	    <thead>
		{headerGroups.map(headerGroup => (
		    <tr {...headerGroup.getHeaderGroupProps()}>
			{headerGroup.headers.map(column => (
			    <th
				tabIndex={0}
                                role="button"
                                aria-sort={column.isSorted ? column.isSortedDesc ? 'descending' : 'ascending': 'none'}
                                onKeyDown={(e) => {
                                    if (column.canSort && (e.key === 'Enter' || e.key === ' ')) {
                                        e.preventDefault(); // Prevent page scroll on Space                     
                                        column.toggleSortBy(!column.isSortedDesc);
                                    }
                                }}
				{...column.getHeaderProps(column.getSortByToggleProps(), {style: {minWidth: column.minWidth, maxWidth: column.maxWidth}})}>
				{column.render('Header')}
				{/* Add a sort direction indicator */}
				<span>
				    {column.isSorted
				     ? column.isSortedDesc
				     ? ' 🔽'
				     : ' 🔼'
				     : ''}    
				</span>
				
			    </th>
			))}
		    </tr>
		))}
	    </thead>
	    <tbody
		{...getTableBodyProps()}
	    >
		{(rows.length > 0 && rows.map((row, i) => {
		    prepareRow(row);
		    const rowProps = row.getRowProps();
		    return (
			<React.Fragment key={i}>
			    <tr  {...row.getRowProps()}>
				{row.cells.map(cell => {
				    return (
					<td
					    {...cell.getCellProps({style: {minWidth:cell.column.minWidth, maxWidth: cell.column.maxWidth}})}>{cell.render('Cell')}</td>
				    )
				})}
			    </tr>
			    {row.isExpanded ? (
				showRowExpansion({ row, rowProps, visibleColumns })
			    ) : null}                                                                   
			</React.Fragment> 
		    )
		})) ||  <tr><td colSpan={visibleColumns.length} className="text-center">No data ...</td></tr>}
	    </tbody>
	</BTable>
    )
}


export default SubRowTable;
